module.exports = __webpack_public_path__ + "img/train-01.805bacb8.png";